module.exports = __webpack_public_path__ + "static/media/01.616d82ef.png";